import { NgClass } from '@angular/common'
import { Component, computed, input, ResourceRef, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

/**
 * Ein Reload Icon Button der sich an eine Resource bindet und den Ladezustand anzeigt.
 */
@Component({
  selector: 'lib-reload-button',
  imports: [NgClass, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './reload-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './reload-button.component.scss',
})
export class ReloadButtonComponent {
  readonly resource = input.required<ResourceRef<unknown> | ResourceRef<unknown>[]>()
  readonly isLoadingOrReloading = computed(() => {
    const result = this.resource()
    if (Array.isArray(result)) {
      return result.some((res) => res.status() === 'loading' || res.status() === 'reloading')
    }
    return result.status() === 'loading' || result.status() === 'reloading'
  })

  reload() {
    const result = this.resource()
    if (Array.isArray(result)) {
      result.forEach((res) => res.reload())
    } else {
      result.reload()
    }
  }
}
